import React, { useCallback } from "react";
import { ChakraProps } from "@chakra-ui/react";
import { AsyncSearchProvider } from "./AsyncSearchProvider";
import AsyncSelect from "./AsyncSelect";
import useAllegiances from "../../hooks/allegiances/useAllegiances";

interface SelectAllegianceProps extends ChakraProps {
  value: string;
  setValue: (value: string) => void;
}

const SelectAllegiance: React.FC<SelectAllegianceProps> = ({ color, value, setValue, ...chakraProps }) => {
  const { isLoading, error, allegiances = [] } = useAllegiances();

  const handleSearch = useCallback(
    async (searchQuery?: string): Promise<[string, string][]> => {
      return allegiances
        .filter(({ displayName }) => displayName.toLowerCase().includes(searchQuery?.toLowerCase().trim() ?? ""))
        .map(({ allegianceId, displayName, category }) => [allegianceId, `${displayName} - ${category}`]);
    },
    [allegiances]
  );

  return (
    <AsyncSearchProvider onSearchAsync={handleSearch}>
      <AsyncSelect
        selectedValue={value}
        setSelectedValue={setValue}
        color={color}
        title={"Allegiance"}
        isLoading={isLoading}
        error={error}
        {...chakraProps}
      />
    </AsyncSearchProvider>
  );
};

export default SelectAllegiance;
